import React from "react";
import { connect } from "react-redux";
const OptionPackages = props => {
  if (
    typeof props.compare != "undefined" &&
    typeof props.compare.nomenclature != "undefined"
  ) {
    
    var nomenclature = props.compare.nomenclature.filter(item => {
      if (item.name === props.compare.type) return item;
    });
    if (nomenclature.length > 0) nomenclature = nomenclature[0];

   
  }
  var option_packages = nomenclature.nomenclature.filter(nomenclatureitem => {
    if (nomenclatureitem.type === "Option Packages") return true;
  });
  if (option_packages.length >= 1) {
    option_packages = option_packages[0].trans;
  } else {
    option_packages = [];
  }

  const items = option_packages.map(item => {
    return (
      <tr key={item.key}>
        <td>{item.value}</td>
        <td>{item.key[0]}</td>
        <td>{item.key[1]}</td>
        <td>{item.key[2]}</td>
        <td>{item.key[3]}</td>
        <td>{item.key[4]}</td>
      </tr>
    );
  });
  if (option_packages.length === 0) {
    return <React.Fragment></React.Fragment>;
  }
  return (
    <div
      style={
        props.compare.type === "PRO3"
          ? { display: "none" }
          : { display: "block" }
      }
      className="datagrid-wrapper"
    >
      <h2>
        Factory Installed: Preferred Option Packages
        <span className="cross">†</span>
      </h2>
      <div className="datagrid-table">
        <table cellPadding="0" cellSpacing="0" width="100%">
          <thead>
            <tr>
              <th colSpan="6">Description</th>
            </tr>
          </thead>
          <tbody>{items}</tbody>
        </table>
      </div>
      <div className="cross_note">
        {props.compare.type === "HTS" ? (
          <ul className="awefnotes">
            <li>
              <h4>Notes</h4>
            </li>
            <li>
              <span>*FSEC = Fixed Speed EC Motor</span>
            </li>
            <li>
              <span>†</span>
              <span>Please contact the factory at </span>
              <a href="tel:+18003211881">
                <span> (800)-321-1881</span>
              </a>
              <span> for other factory installed options.</span>
            </li>
          </ul>
        ) : (
          <ul className="awefnotes">
            <li>
              <h4>Notes</h4>
            </li>
            <li>
              <span>†</span>
              <span>Please contact the factory at </span>
              <a href="tel:+18003211881">
                <span> (800)-321-1881</span>
              </a>
              <span> for other factory installed options.</span>
            </li>
          </ul>
        )}
      </div>
      <nav className="nav nav-tabs print_style" role="tablist">
        <a
          href="#"
          role="tab"
          data-rb-event-key="Model-Nomenclature"
          aria-selected="false"
          className="nav-item nav-link"
          tabIndex="-1"
        >
          Model Nomenclature
        </a>
        <a
          href="#"
          role="tab"
          data-rb-event-key="Compare-technical-Data"
          aria-selected="true"
          className="nav-item nav-link active"
        >
          Compare Technical Data
        </a>
      </nav>
    </div>
  );
};

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(OptionPackages);
